import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";

interface LinkDialogProps {
  open: boolean;
  initialUrl?: string;
  initialText?: string;
  onClose: () => void;
  onConfirm: (url: string, text: string) => void;
}

const LinkDialog: React.FC<LinkDialogProps> = ({
  open,
  initialUrl = "https://",
  initialText = "",
  onClose,
  onConfirm,
}) => {
  const [url, setUrl] = useState(initialUrl);
  const [text, setText] = useState(initialText);
  useEffect(() => {
    if (open) {
      setUrl(initialUrl);
      setText(initialText);
    }
  }, [open, initialUrl, initialText]);
  const handleConfirm = () => {
    if (url && url !== "https://") {
      onConfirm(url, text || url);
      onClose();
    }
  };
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleConfirm();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Insert Link</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="Link Text (optional)"
          type="text"
          fullWidth
          variant="outlined"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter link text"
          sx={{ mb: 2 }}
        />
        <TextField
          autoFocus
          margin="dense"
          label="URL"
          type="url"
          fullWidth
          variant="outlined"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="https://example.com"
          required
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!url || url === "https://"}
        >
          Insert
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkDialog;
